export default __webpack_public_path__ + "static/media/rondas.2dda48de.jpg";